import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../molecules/accordion-item/index.js';
import { scrollIntoView } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './styles/accordion.scss.js';
import css_248z$1 from './styles/accordion-filter.scss.js';
import img from '../../../../assets/images/clear-input-large.svg.js';

class Accordion extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.filterTitle = '';
        this.filterClearText = '';
        this.filterNoResultText = '';
        this.backgroundColor = '';
        this.accordionState = 'closed';
    }
    firstUpdated() {
        this.applySectionBehavior();
        setTimeout(() => {
            if (this.scrollToView)
                scrollIntoView(this, document.querySelector('.container > .top'));
        }, 0);
    }
    updated(changedProperties) {
        if (changedProperties.has('accordionState')) {
            this.applySectionBehavior();
        }
    }
    applySectionBehavior() {
        var _a;
        const items = (_a = this.renderRoot
            .querySelector('slot[name="accordion-item"]')) === null || _a === void 0 ? void 0 : _a.assignedElements();
        if (!items)
            return;
        const setIsExpanded = (item, value) => {
            const accordionItem = item;
            if ('isExpanded' in accordionItem) {
                accordionItem.isExpanded = value;
            }
        };
        switch (this.accordionState) {
            case 'first':
                items.forEach((item, index) => setIsExpanded(item, index === 0));
                break;
            case 'open':
                items.forEach(item => setIsExpanded(item, true));
                break;
            case 'closed':
                items.forEach(item => setIsExpanded(item, false));
                break;
        }
    }
    filter(e) {
        var _a, _b;
        const term = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value.toLowerCase();
        const items = (_b = this.renderRoot
            .querySelector('slot')) === null || _b === void 0 ? void 0 : _b.assignedElements();
        const notFoundText = this.renderRoot.querySelector('.filter-not-found');
        const hideCls = 'hide';
        const inputWrapper = this.renderRoot.querySelector('.input-wrapper');
        if (!term) {
            inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.classList.add('empty');
        }
        else {
            inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.classList.remove('empty');
        }
        items === null || items === void 0 ? void 0 : items.forEach(item => {
            var _a, _b;
            item.classList.remove(hideCls);
            if (!((_b = (_a = item
                .shadowRoot.querySelector('.title')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(term))) {
                item.classList.add(hideCls);
            }
        });
        if (items.filter(item => item.classList.contains(hideCls)).length ===
            items.length) {
            notFoundText.classList.remove(hideCls);
        }
        else {
            notFoundText.classList.add(hideCls);
        }
        this.requestUpdate();
    }
    clearFilter() {
        const searchInput = this.shadowRoot.querySelector('.search-term');
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
    }
    renderFilter() {
        return $ `<div class="filter ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="title">${this.filterTitle}</div><div class="input-wrapper empty"><input class="search-term" type="text" aria-label="${this.filterTitle}" @input="${this.filter}" @focus="${(e) => e.target.parentNode.classList.add('focus')}" @blur="${(e) => e.target.parentNode.classList.remove('focus')}"> <button class="clear-input" @click="${this.clearFilter}" aria-label="${this.filterClearText}"><img src="${img}" aria-hidden="true"></button></div></div><span class="filter-not-found hide">${this.filterNoResultText}</span>`;
    }
    render() {
        return $ `<div class="accordion-wrapper accordion-background-${this.backgroundColor}">${this.filterTitle ? this.renderFilter() : null}<slot name="accordion-item"></slot></div>`;
    }
}
Accordion.styles = [css_248z, css_248z$1];
__decorate([
    e({ type: String })
], Accordion.prototype, "filterTitle", void 0);
__decorate([
    e({ type: String })
], Accordion.prototype, "filterClearText", void 0);
__decorate([
    e({ type: String })
], Accordion.prototype, "filterNoResultText", void 0);
__decorate([
    e({ type: Boolean })
], Accordion.prototype, "scrollToView", void 0);
__decorate([
    e({ type: String })
], Accordion.prototype, "backgroundColor", void 0);
__decorate([
    e({ type: String })
], Accordion.prototype, "accordionState", void 0);
customElements.define('cvt-accordion', Accordion);

export { Accordion };
